exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vc-chrome[data-v-75243b72]{position:absolute;top:50px;left:0;z-index:99}.current-color[data-v-75243b72]{display:inline-block;width:18px;height:18px;margin:6px 10px 0 0;background-color:#000;cursor:pointer}", "", {"version":3,"sources":["C:/wamp/www/cortexial/cortexial-app/src/util/ColorPicker.vue"],"names":[],"mappings":"AACA,4BACE,kBAAmB,AACnB,SAAU,AACV,OAAQ,AACR,UAAY,CACb,AACD,gCACE,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,sBAAuB,AACvB,cAAgB,CACjB","file":"ColorPicker.vue","sourcesContent":["\n.vc-chrome[data-v-75243b72] {\r\n  position: absolute;\r\n  top: 50px;\r\n  left: 0;\r\n  z-index: 99;\n}\n.current-color[data-v-75243b72] {\r\n  display: inline-block;\r\n  width: 18px;\r\n  height: 18px;\r\n  margin: 6px 10px 0 0;\r\n  background-color: #000;\r\n  cursor: pointer;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75243b72","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/util/ColorPicker.vue
// module id = 486
// module chunks = 0 1 2 3 4